import { methods, request } from "./base";

const programApis = {
  getProgramRecords: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/patient/get_patient_record_onco_without_visit_id",
      payload: data,
    }),

  uploadProgramsRecords: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/patient/updated_records",
      payload: data,
    }),

  getProgramDetailsGfc: async () =>
    await request({
      method: methods.GET,
      route: "/patient/program_details_gfc",
      priv: true,
      encrypt: false,
    }),

  benefitAction: async (payload: { benefit_name: string; addressId: string }) =>
    await request({
      method: methods.POST,
      route: "/patient/benefit_action",
      payload,
      priv: true,
      encrypt: true,
    }),
};

export default programApis;
